const WEB_DEEP_LINK_HOSTS = new Set(["lapstr.se", "www.lapstr.se"]);
const NATIVE_SCHEMES = new Set(["lapstr:", "lapstr-dev:"]);

function internalDestination(url, pathname) {
  if (!pathname.startsWith("/") || pathname.startsWith("//") || pathname.includes("\\")) {
    return null;
  }

  return `${pathname}${url.search}${url.hash}`;
}

export function resolveNativeDeepLink(rawUrl) {
  if (!rawUrl || typeof rawUrl !== "string") return null;

  let url;
  try {
    url = new URL(rawUrl);
  } catch {
    return null;
  }

  if (NATIVE_SCHEMES.has(url.protocol)) {
    const hostPath = url.hostname && url.hostname !== "app" ? `/${url.hostname}` : "";
    return internalDestination(url, `${hostPath}${url.pathname || "/"}`);
  }

  if (
    (url.protocol === "https:" || url.protocol === "http:")
    && WEB_DEEP_LINK_HOSTS.has(url.hostname.toLowerCase())
  ) {
    return internalDestination(url, url.pathname || "/");
  }

  return null;
}
